// import api from '@/api/commentApi'

const state = {
  user: {
    // 'member_id': '',
    // 'display_name': '未ログインユーザー',
    // 'avatar_url': '/assets_common/img/common/user-default-icon.svg',
    // 'last_check_at': 0
  }
}

const mutations = {
  userDataGet: (state, payload) => {
    state.user = payload
    // console.log(state.user, 'state.user')
  }
}

const actions = {
  userDataGet: ({ commit }, payload) => {
    // payload member_id
    // localStorage
    var userData = JSON.parse(localStorage.getItem(payload.detail))

    userData.avatar_url = (userData.avatar_url !== 'noimage') ? userData.avatar_url : '/assets_common/img/common/user-default-icon.svg'
    userData.idOnly = (userData.role === undefined)
    // ログイン確認できれば state.userにデータを入れる
    commit('userDataGet', userData)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/components/userData.js